import { Component, DoCheck, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map, filter, switchMap } from 'rxjs/operators';
import { Ad, cpDcService } from 'src/app/services/cp-dc/cp-dc.service';
import { cpmService } from 'src/app/services/cp-dc/cpm.service';
import { MusicService } from 'src/app/services/music.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { expandCollapse } from './animations';
import { Location } from '@angular/common';
interface Track {
  title: string;
  link: string;
  trackImage: string;
  duration?: string;
  artist?: string;
}

@Component({
  selector: 'app-music-modal',
  templateUrl: './music-modal.component.html',
  styleUrls: ['./music-modal.component.scss'],
  animations: [expandCollapse]
})
export class MusicModalComponent implements OnInit, DoCheck {
  @Input() openMuiscPopUp: boolean;
  private previousDisplayAd1: boolean = false;
  displayAd1: boolean = false;
  videoStarted: boolean = false;
  showAd: boolean = true;

  get modalState() {
    return this.openMuiscPopUp ? 'expanded' : 'collapsed';
  }

  add: Ad | null = null;



  constructor(private readonly musicService: MusicService,
    private location: Location,
    private router: Router,
  ) { }

  close(): void {
    this.audio.pause();
    this.showAd = false;
      const currentPath = this.location.path().split('?')[0];
    this.location.go(currentPath); 
    this.musicService.updateOpenMusicSub(false);
  }

  isPlaying = false;
  currentTrackIndex = 0;
  currentTrack: Track;
  currentTime = '00:00';
  duration = '00:00';
  progress = 0;
  audio = new Audio();
  hoveredIndex: number | null = null;
  albumName = '';

  tracks: Track[] = [];

  ngOnInit(): void {

    this.musicService.musicSub$.subscribe(res => {
      this.albumName = res.albumName;
      this.tracks = res.playlist;
    });
    this.tracks.forEach((track, index) => {
      const audio = new Audio(track.link);
      audio.addEventListener('loadedmetadata', () => {
        this.tracks[index].duration = this.formatTime(audio.duration);
      });
    });

    this.currentTrack = this.tracks[this.currentTrackIndex];
    this.audio.src = this.currentTrack.link;
    this.audio.addEventListener('timeupdate', this.updateTime.bind(this));
    this.audio.addEventListener('loadedmetadata', this.updateDuration.bind(this));
    this.audio.addEventListener('ended', this.audioEnd.bind(this));
    //this.onPlayPause();

    //document.addEventListener('click', this.handleClick);
    if(this.isIOS()) {
      this.showAd = false;
      setTimeout(() => {
        this.showAd = true;
      },0);
      this.onPlayPause();
    }
  }

  isIOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
 }

  handleClick = (event: Event) => {
    let element = event.target as HTMLElement;

    while (element) {
      if (element.tagName === 'VG-IMA-ADS') {
        //alert('Click is from inside vg-ima-ads');

        this.displayAd1 = false;
        this.showAd = false;
        return;
      }
      element = element.parentElement;
    }
  }

  audioEnd() {
    this.isPlaying = false;
    if(this.tracks.length > 1 && this.currentTrackIndex !== (this.tracks.length -1)) {
      this.isPlaying = false;
      this.onNext()
    }
  }
  

  updateTime() {
    this.currentTime = this.formatTime(this.audio.currentTime);
    this.progress = (this.audio.currentTime / this.audio.duration) * 100;
  }

  updateDuration() {
    this.duration = this.formatTime(this.audio.duration);
  }

  formatTime(time: number): string {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  onBack() {
    console.log('Back button clicked');
  }

  onPrev() {
    if(this.displayAd1) { 
      return;
    }
    this.showAd = false;
    setTimeout(() => {
      this.showAd = true;
    },0);
    if (this.currentTrackIndex > 0) {
      this.currentTrackIndex--;
      this.setTrack();
    }
  }

  onNext() {
    if(this.displayAd1) { 
      return;
    }
    this.showAd = false;
    setTimeout(() => {
      this.showAd = true;
    },0);
    if (this.currentTrackIndex < this.tracks.length - 1) {
      this.currentTrackIndex++;
      this.setTrack();
    }
  }

  onPlayPause() {
    if(this.displayAd1) { 
      return;
    }
    this.isPlaying = !this.isPlaying;
    if (this.isPlaying) {
      this.audio.play();
    } else {
      this.audio.pause();
    }
  }

  setTrack() {
    this.audio.pause();
    this.currentTrack = this.tracks[this.currentTrackIndex];
    this.audio.src = this.currentTrack.link;
    if (this.isPlaying) {
      this.audio.play();
    }
    this.updateDuration();
  }

  selectTrack(index: number) {
    if(this.displayAd1) {
      return;
    }
    if (this.currentTrackIndex === index) {
      this.onPlayPause();
    } else {
      this.showAd = false;
      setTimeout(() => {
        this.showAd = true;
      },0);
      this.currentTrackIndex = index;
      this.setTrack();
      this.isPlaying = true;
      this.audio.play();
    }
  }

  videoEnded(string: any): void {

  }

  play(): void {
    this.isPlaying = true;
    this.audio.play();
  }

  videoStart(x:any) {
    this.videoStarted = (x === "END") ? false : true;
    if(this.videoStarted) {
      setTimeout(() => {
        if(this.displayAd1) {
           this.pause();
        }
      },1000)
    } else {
       this.play()
    }
  }

  pause() {
    this.isPlaying = false;
    this.audio.pause();
  }

  onSliderChange(event: any): void {
    const newTime = (event.value / 100) * this.audio.duration;
    this.currentTime = this.formatTime(newTime);
  }
  
  onSliderChangeEnd(event: any): void {
    const newTime = (event.value / 100) * this.audio.duration;
    this.audio.currentTime = newTime;
    //this.updateTime();
  }



  ngDoCheck(): void {
    // Custom change detection logic
    this.checkVgImaAdsElements();
  }

  private checkVgImaAdsElements(): void {
    const vgImaAdsElements = document.querySelectorAll('vg-ima-ads');
    vgImaAdsElements.forEach((element) => {
      const computedStyle = window.getComputedStyle(element);
      const displayState = computedStyle.getPropertyValue('display') === 'block';

      // Only update displayAd1 if there's a change in the display state
      if (displayState !== this.previousDisplayAd1) {
        this.displayAd1 = displayState;
        this.previousDisplayAd1 = displayState;
        if(this.displayAd1) {
          setTimeout(() => {
           if(this.displayAd1) {
            this.pause();
           }
          },1000);
        } else {
          this.play()
        }
      }
    });
  }
}
